module.exports = __webpack_public_path__ + "img/thumb_06.d641d41e.jpg";